import { UseControllerProps } from 'react-hook-form/dist/types/controller';
import { TValidation } from 'entries/common/widgets/context';
import { ValidationTypes } from 'pages/common/consts/frontend-configuration';
import { getLabelText } from '../../../helpers';

const getDecimalPrecisionFn = (decimalPrecision: number) =>
  new RegExp(String.raw`^\d+(\.\d{1,${decimalPrecision}})?$`);

export const getValidationRules = (validations?: TValidation[]) => {
  const validationRules: UseControllerProps['rules'] = {};

  if (!validations || validations.length === 0) {
    return null;
  }

  validations.forEach(validation => {
    switch (validation.type) {
      case ValidationTypes.REQUIRED:
        validationRules.required = getLabelText(validation.errorText);
        break;
      case ValidationTypes.MIN:
        if (validation.params && 'min' in validation.params) {
          validationRules.min = {
            value: validation.params.min,
            message: getLabelText(validation.errorText),
          };
        }
        break;
      case ValidationTypes.MAX:
        if (validation.params && 'max' in validation.params) {
          validationRules.max = {
            value: validation.params.max,
            message: getLabelText(validation.errorText),
          };
        }
        break;
      case ValidationTypes.RANGE:
        validationRules.validate = (value: string | number | boolean) => {
          if (
            typeof value !== 'boolean' &&
            validation.params &&
            'min' in validation.params &&
            'max' in validation.params
          ) {
            return Number(value) < validation.params.min || Number(value) > validation.params.max
              ? getLabelText(validation.errorText)
              : true;
          }

          return true;
        };
        break;
      case ValidationTypes.DECIMAL_PRECISION:
        if (validation.params && 'decimalPrecision' in validation.params) {
          validationRules.pattern = {
            value: getDecimalPrecisionFn(validation.params.decimalPrecision),
            message: getLabelText(validation.errorText),
          };
        }
        break;
      case ValidationTypes.INTEGER_ONLY:
        validationRules.validate = (value: string | number | boolean) => {
          const checkedValue = typeof value === 'string' ? Number(value) : value;

          return Number.isInteger(checkedValue) ? true : getLabelText(validation.errorText);
        };
        break;
      default:
        break;
    }
  });

  return validationRules;
};
